import {FETCH_WORKER_REQUEST, FETCH_WORKER_ERROR, FETCH_WORKER_SUCCES} from '../constants/Worker'

const initialState = {
  item: {},
  hasErrored: false,
  isLoading: false
}

export default function WORKER(state = initialState, action) {
  switch (action.type) {
      case FETCH_WORKER_REQUEST:
        return {...state, isLoading: true};
      case FETCH_WORKER_SUCCES:
        return {...state, item: action.payload, isLoading: false};
      case FETCH_WORKER_ERROR:
        return {...state, hasErrored: true, isLoading: false};
      default:
          return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/worker.js